import axios from "axios";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

export const api = axios.create({
  headers: { "X-NZ-Token": cookies.get('goto') },
  maxContentLength: 100 * 1024 * 1024,
  validateStatus: function (status) {
    if (status == 401) {
      cookies.set('goto', "", { path: '/' });
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_adm = axios.create({
  headers: { "X-NZ-Token": cookies.get('goto_adm'), },
  maxContentLength: 50 * 1024 * 1024,
  validateStatus: function (status) {
    if (status == 401) {
      cookies.set('goto_adm', "", { path: '/' });
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_2fa = axios.create({
  headers: { "X-NZ-Token": cookies.get('goto_2fa'), },
  maxContentLength: 50 * 1024 * 1024,
  validateStatus: function (status) {
    if (status == 401) {
      cookies.set('goto_2fa', "", { path: '/' });
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});

export const api_repre = axios.create({
  headers: { "X-NZ-Token": cookies.get('goto_repre') },
  validateStatus: function (status) {
    if (status == 401) {
      cookies.set('goto_repre', "", { path: '/' });
      if (window.location.pathname != "/") {
        window.location.href = "/";
      }
      return true;
    }
    return true;
  },
});